<script setup lang="js">
import { onMounted } from 'vue';

onMounted(async () => {
  const card = await document.getElementById('card');

  function clickRotate() {
    if(card != null)
    {
      card.classList.toggle('rotated');
    }
  }

  if(card != null)
  {
    card.addEventListener('click', clickRotate);
  }
})
</script>

<template>
  <body>
  <div class="cards-wrapper">
    <div class="card-container">
      <div id="card" class="card">
        <div class="card-contents card-front">
          <div class="card-depth">
            <h2>LeadTech</h2>
            <hr>
            <p>Inbound marketing</p>
          </div>
        </div>
        <div class="card-contents card-back">
          <div class="card-depth">
            <h2>Inovativ Userfrendly Inbound Marketing</h2>
            <hr>
            <p>Solutions</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</body>
</template>

<style lang="css" scoped>
body {
  background: linear-gradient(to right, #141e30, #243b55);
}

h1, h2, h3, h4, p {
  color: #FFFFFF;
  font-family: Arial, sans-serif;
}


.header {
  text-align: center;
  span {
    padding-right: 5px;
  }
}

.cards-wrapper {
  margin: 0 0;
  padding: 0 0;
}
.card-container {
  perspective: 800px;
  padding: 50px 0;
}
.card {
  margin: 0 auto;
  height: 500px;
  width: 500px;
  max-width: 80%;
  position: relative;
  border-radius: 25px;
  transition: all 1s ease;
  transform-style: preserve-3d;
  box-shadow: 1px 3px 3px rgba(0,0,0,0.2)
}

.rotated {
  transform: rotateY(-180deg);
}
.card-contents {
  width: 100%;
  height: 100%;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  backface-visibility: hidden;
  h2, p {
    text-shadow: 1px 2px 2px rgba(0,0,0,0.2);
  }
  h2 {
    font-size: 2.5em;
    margin: 0 auto;
  }
  hr {
    width: 50%;
    margin: 20px auto;
  }
  p {
    margin: 0 auto;
  }
}
.card-depth {
   transform: translateZ(100px) scale(0.98);
   perspective: inherit;

}
.card-front {
  background: linear-gradient(to top left, #3a6186, #89253e);           
  transform-style: preserve-3d;
}
.card-back {
  transform: rotateY(180deg);
  background: linear-gradient(to top left, #ffa17f, #00223e);
  transform-style: preserve-3d;
}
</style>